const MetricCopyright = ({ name }) => (
  <>{name}<sup style={{ fontSize: '0.55em' }}>©</sup></>
);

export default MetricCopyright;
